function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.453,
    height: 19.647,
    viewBox: "0 0 19.453 19.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5084",
    d: "m21.643 11.064-1.178-.548c.023-.246.034-.472.034-.693s-.011-.447-.034-.693l1.178-.549a.576.576 0 0 0 .3-.7l-.711-2.19a.576.576 0 0 0-.658-.387l-1.271.248a8.275 8.275 0 0 0-.819-1.12l.635-1.132a.576.576 0 0 0-.165-.745L17.091 1.2a.576.576 0 0 0-.76.073l-.887.952a8.192 8.192 0 0 0-1.315-.425L13.971.506A.576.576 0 0 0 13.4 0h-2.3a.576.576 0 0 0-.571.506l-.16 1.294a8.187 8.187 0 0 0-1.316.429l-.887-.952a.576.576 0 0 0-.76-.073L5.543 2.553a.576.576 0 0 0-.165.745l.631 1.136a8.269 8.269 0 0 0-.819 1.12l-1.271-.248a.576.576 0 0 0-.658.387l-.711 2.19a.576.576 0 0 0 .3.7l1.178.549C4.01 9.377 4 9.6 4 9.823s.011.447.034.693l-1.178.548a.576.576 0 0 0-.3.7l.711 2.19a.576.576 0 0 0 .658.387l1.271-.248a8.272 8.272 0 0 0 .819 1.119l-.631 1.136a.576.576 0 0 0 .165.745l1.863 1.353a.576.576 0 0 0 .76-.073l.887-.952a8.192 8.192 0 0 0 1.316.429l.158 1.29a.576.576 0 0 0 .571.506h2.3a.576.576 0 0 0 .571-.506l.158-1.29a8.187 8.187 0 0 0 1.316-.429l.887.952a.576.576 0 0 0 .76.073l1.863-1.353a.576.576 0 0 0 .165-.745l-.631-1.136a8.269 8.269 0 0 0 .819-1.12l1.271.248a.576.576 0 0 0 .658-.387l.711-2.19a.576.576 0 0 0-.3-.7zm-9.394 4.323a5.564 5.564 0 1 1 5.564-5.564 5.57 5.57 0 0 1-5.564 5.564z",
    style: {
      fill: "#d9d9d9"
    },
    transform: "translate(-2.522)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "user (7)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5082",
    d: "M89 3.94a1.906 1.906 0 0 0 1.393-.577 1.906 1.906 0 0 0 .577-1.393 1.907 1.907 0 0 0-.575-1.393 1.97 1.97 0 0 0-2.786 0 1.906 1.906 0 0 0-.577 1.393 1.906 1.906 0 0 0 .577 1.393A1.907 1.907 0 0 0 89 3.94zm0 0",
    transform: "translate(-79.326 5.342)",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5083",
    d: "M6.808 249.529a4.367 4.367 0 0 0-.066-.489 3.679 3.679 0 0 0-.127-.492 2.363 2.363 0 0 0-.214-.458 1.745 1.745 0 0 0-.322-.4 1.433 1.433 0 0 0-.463-.275 1.68 1.68 0 0 0-.591-.1.619.619 0 0 0-.32.128l-.334.2a1.968 1.968 0 0 1-.432.18 1.767 1.767 0 0 1-1.056 0 1.963 1.963 0 0 1-.431-.18l-.334-.2a.618.618 0 0 0-.32-.128 1.678 1.678 0 0 0-.591.1 1.433 1.433 0 0 0-.463.275 1.745 1.745 0 0 0-.322.4 2.369 2.369 0 0 0-.214.459 3.688 3.688 0 0 0-.127.492 4.353 4.353 0 0 0-.066.489c-.011.148-.016.3-.016.457a1.4 1.4 0 0 0 .21.972s.749 1.1 3.1 1.1a4.4 4.4 0 0 0 3.3-1.1 1.655 1.655 0 0 0 .21-.972c0-.156-.006-.31-.017-.457zm0 0",
    transform: "translate(6.315 -237.752)",
    style: {
      fill: "#d9d9d9"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.bfdb38e0bf3df00c177ad97484b73c40.svg";
export { ForwardRef as ReactComponent };